import type { MyFilesBreadcrumb } from "@nlc/shared-types";
import type { MyFilesResponse } from "@nlc/shared-types";

import { RequestTypeEnum } from "@nlc/shared-types";

export function getMyFilesStructureTemplateData(
  requestType: RequestTypeEnum.GRAPHIC | RequestTypeEnum.VIDEO | undefined,
): {
  breadcrumbs: MyFilesBreadcrumb[];
  structure: MyFilesResponse["structure"];
} {
  return buildMockData(requestType);
}

function buildMockData(requestType: RequestTypeEnum | undefined) {
  const breadcrumbs: MyFilesBreadcrumb[] = [
    {
      id: 0,
      label: "Demo account",
      slug: "account",
    },
    {
      id: "unknown",
      label: "Requests w/o brand",
      slug: "brand",
    },
    {
      id: "graphic",
      label: "Graphic",
      slug: "requestType",
    },
    {
      id: 0,
      label: "Fall collection ads",
      slug: "request",
    },
  ];

  const isGraphic = requestType === RequestTypeEnum.GRAPHIC;

  if (isGraphic) {
    return { breadcrumbs, structure: mockGraphicStructure() };
  }

  return { breadcrumbs, structure: mockVideoStructure() };
}

function mockGraphicStructure(): MyFilesResponse["structure"] {
  const baseDate = new Date("2025-10-21T15:00:00.000Z");

  return {
    children: [
      {
        createdAt: new Date(baseDate.getTime()),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "png",
        id: 1001,
        isDirectory: false,
        isSourceFile: false,
        label: "1-1080x1080",
        projectName: "felipe empire",
        requestId: "85611",
        size: "245000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime()),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/1-1080x1080.png",
        version: 1,
      },
      {
        createdAt: new Date(baseDate.getTime() + 2000),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "png",
        id: 1002,
        isDirectory: false,
        isSourceFile: false,
        label: "1-1080x1920",
        projectName: "felipe empire",
        requestId: "85611",
        size: "312000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime() + 2000),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/1-1080x1920.png",
        version: 1,
      },
      {
        createdAt: new Date(baseDate.getTime() + 4000),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "png",
        id: 1003,
        isDirectory: false,
        isSourceFile: false,
        label: "2-1080x1080",
        projectName: "felipe empire",
        requestId: "85611",
        size: "268000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime() + 4000),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/2-1080x1080.png",
        version: 1,
      },
      {
        createdAt: new Date(baseDate.getTime() + 6000),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "png",
        id: 1004,
        isDirectory: false,
        isSourceFile: false,
        label: "2-1080x1920",
        projectName: "felipe empire",
        requestId: "85611",
        size: "335000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime() + 6000),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/2-1080x1920.png",
        version: 1,
      },
      {
        createdAt: new Date(baseDate.getTime() + 8000),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "png",
        id: 1005,
        isDirectory: false,
        isSourceFile: false,
        label: "3-1080x1920",
        projectName: "felipe empire",
        requestId: "85611",
        size: "298000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime() + 8000),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Graphics+Template/3-1080x1920.png",
        version: 1,
      },
      {
        id: "unknown",
        isDirectory: true,
        label: "Source files",
        size: "0",
        slug: "sourcefiles",
      },
      {
        id: "unknown",
        isDirectory: true,
        label: "Archive",
        size: "0",
        slug: "archive",
      },
    ],
    id: 0,
    isDirectory: true,
    label: "Fall collection ads",
    size: "1458000",
    slug: "request",
  };
}

function mockVideoStructure(): MyFilesResponse["structure"] {
  const baseDate = new Date("2025-10-21T15:00:00.000Z");

  return {
    children: [
      {
        createdAt: new Date(baseDate.getTime()),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "mp4",
        id: 2001,
        isDirectory: false,
        isSourceFile: false,
        label: "1-1080x1920",
        projectName: "Demo project",
        requestId: "85611",
        size: "5240000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime()),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/1-1080x1920.mp4",
        version: 1,
      },
      {
        createdAt: new Date(baseDate.getTime() + 2000),
        designerInitials: "JG",
        designerShortName: "Jason G",
        extension: "mp4",
        id: 2002,
        isDirectory: false,
        isSourceFile: false,
        label: "2-1080x1920",
        projectName: "Demo project",
        requestId: "85611",
        size: "4890000",
        slug: "file",
        updatedAt: new Date(baseDate.getTime() + 2000),
        url: "https://nlc-assets-prod.s3.us-east-2.amazonaws.com/request-templates/Videos+Template/2-1080x1920.mp4",
        version: 1,
      },
      {
        id: "unknown",
        isDirectory: true,
        label: "Source files",
        size: "0",
        slug: "sourcefiles",
      },
      {
        id: "unknown",
        isDirectory: true,
        label: "Archive",
        size: "0",
        slug: "archive",
      },
    ],
    id: 85_611,
    isDirectory: true,
    label: "Fall collection ads",
    size: "10130000",
    slug: "request",
  };
}
